"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateInputId = exports.mapBsStyleToColor = void 0;

var _react = require("react");

var colors = _interopRequireWildcard(require("./colors"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function createUniqueId(label) {
  var uniqueId = "".concat(label, "-").concat(Math.floor(Math.random() * 0xffff));
  return uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
} // eslint-disable-next-line import/prefer-default-export


var mapBsStyleToColor = function mapBsStyleToColor(bsStyle) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$shade = _ref.shade,
      shade = _ref$shade === void 0 ? 'base' : _ref$shade,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? colors.coal : _ref$fallback;

  var result = colors[bsStyle];

  if (result && result[shade]) {
    result = result[shade];
  } else {
    result = fallback;
  }

  return result;
};

exports.mapBsStyleToColor = mapBsStyleToColor;

var useCreateInputId = function useCreateInputId(id, label) {
  var inputRef = (0, _react.useRef)(null);

  if (inputRef.current === null) {
    inputRef.current = id || createUniqueId(label);
  }

  return inputRef.current;
};

exports.useCreateInputId = useCreateInputId;